module.exports = __webpack_public_path__ + "img/bookmarks-fill.50dd59a3.svg";